"use strict";

angular.module("customer")
.component("productPreferred", {
    bindings: {
        catalogEntry: "=",
        vendor: "=?",
        instanceIndex: "<?"
    },
    templateUrl: require("./product-preferred.component.html"),
    controllerAs: 'productPreferredCtrl',
    controller: function($rootScope, $scope, PreferredService, common) {
        var _this = this;

        this.togglePreferred = function($event, index) {
            $event.stopPropagation();

            if ($scope.isFetching) {
                return;
            }

            $scope.isFetching = true;
            PreferredService.updateCatalogEntry(this.catalogEntry).then(function(updatedCatalogEntry) {
                if (_this.vendor && _this.vendor.catalogEntries && $rootScope.preferredMode && !updatedCatalogEntry.preferred) {
                    _this.vendor.catalogEntries.splice(index, 1);
                    common.setItemOrderIndex(1, _this.vendor.catalogEntries);
                }
                _this.catalogEntry.preferred = updatedCatalogEntry.preferred;
            }).finally(function() {
                $scope.isFetching = false;
            });
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/produt-preferred/product-preferred.component.js
// module id = 857
// module chunks = 0